import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchAssistantInsightsSummary,
  fetchAssistantInsightsWorkspaces,
} from '@/api/assistantInsights/assistantInsightsApi';
import type {
  AssistantInsightsFilters,
  InsightsSummary,
  InsightsWorkspace,
} from '@/api/assistantInsights/assistantInsightsApi.types';
import { buildInsightsQueryParameters } from '@/api/assistantInsights/assistantInsightsMapping';
import type { PaginatedResult } from '@/api/pagination.types';
import { ADMIN_LIST_PAGE_SIZE } from '@/constants/adminPagination';
import {
  buildAssistantInsightsSummaryQueryKey,
  buildAssistantInsightsWorkspacesQueryKey,
} from '@/constants/queryKeys';

export function useAssistantInsightsSummaryQuery(
  filters: AssistantInsightsFilters
): UseQueryResult<InsightsSummary> {
  return useQuery({
    queryKey: buildAssistantInsightsSummaryQueryKey(buildInsightsQueryParameters(filters)),
    queryFn: function loadSummary() {
      return fetchAssistantInsightsSummary(filters);
    },
    placeholderData: keepPreviousData,
  });
}

export function useAssistantInsightsWorkspacesQuery(
  filters: AssistantInsightsFilters,
  page: number,
  search: string
): UseQueryResult<PaginatedResult<InsightsWorkspace>> {
  return useQuery({
    queryKey: buildAssistantInsightsWorkspacesQueryKey(
      buildInsightsQueryParameters(filters),
      page,
      search
    ),
    queryFn: function loadWorkspaces() {
      return fetchAssistantInsightsWorkspaces(filters, page, ADMIN_LIST_PAGE_SIZE, search);
    },
    placeholderData: keepPreviousData,
  });
}
